import { useMemo, useSyncExternalStore } from 'react';
// eslint-disable-next-line no-restricted-imports
import { t } from '@transifex/native';
import { createTxInstanceCache, loadSpaModule, } from '@vend/utilities';
import { HELIOS_TRANSIFEX_TAG, HELIOS_TRANSIFEX_TOKEN, overrideHeliosTXInstance, } from '@lightspeed/design-system-react';
let instance = null;
let listeners = [];
const addListener = (listener) => {
    listeners = [...listeners, listener];
};
const removeListener = (listener) => {
    listeners = listeners.filter(l => l !== listener);
};
const updateListeners = () => {
    listeners.forEach(listener => {
        listener();
    });
};
const getInstance = () => instance;
const subscribe = (cb) => {
    addListener(cb);
    return () => removeListener(cb);
};
const loadInstance = async () => {
    try {
        instance = await loadSpaModule('@vend-spa/tx-manager');
        updateListeners();
    }
    catch (_a) {
        // Deliberate degradation: tx-manager shares translation files between
        // packages. If it cannot be loaded we still serve translations via a local
        // cache, just without the cross-package sharing.
        instance = createTxInstanceCache();
        updateListeners();
    }
};
loadInstance();
export const useTXManager = (tag, token, preloadTags) => {
    const instanceCache = useSyncExternalStore(subscribe, getInstance);
    const result = useMemo(() => {
        if (!instanceCache) {
            return {
                txInstance: {
                    t,
                    setCurrentLocale: () => Promise.resolve(),
                    controllerOf: () => { },
                    init: () => { },
                },
            };
        }
        if (preloadTags && preloadTags.length) {
            preloadTags.forEach(tag => {
                const isHelios = tag === HELIOS_TRANSIFEX_TAG;
                const instance = instanceCache.getTxInstance(tag, isHelios ? HELIOS_TRANSIFEX_TOKEN : token);
                if (isHelios) {
                    overrideHeliosTXInstance(instance);
                }
            });
        }
        return Object.assign({ txInstance: instanceCache.getTxInstance(tag, token) }, instanceCache);
    }, [preloadTags, tag, token, instanceCache]);
    return result;
};
